// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.inputText[data-v-0896cc48] {\n  display: block;\n  background-color: #f0f0f2;\n  border-radius: 0.3125rem;\n  font-size: 0.8125rem;\n  height: 40px;\n  width: 100%;\n  padding: 10px;\n}\n.error[data-v-0896cc48] {\n  border: solid red 2px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
